export enum SupportedPlugin {
  Incident = 'grafana-incident-app',
  OnCall = 'grafana-oncall-app',
  MachineLearning = 'grafana-ml-app',
  Labels = 'grafana-labels-app',
  Slo = 'grafana-slo-app',
}
